(function ($) {
  $(window).on('scroll', function () {
    $('.addtoany-container').each(function () {
      const sticky = $(this);
      const stickyBottom = sticky.offset().top + sticky.outerHeight(true);
      const parentBottom = sticky.parent().offset().top + sticky.parent().outerHeight(true);

      if (stickyBottom >= parentBottom) {
        sticky.css('z-index', 1);
      } else {
        sticky.css('z-index', 9999);
      }
    });
  });
})(jQuery);